import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '../../common/headers/ModalHeader';

// Utils

import { currencyTools } from '../../../utils/tools/currencyTools';


const ExpectedIncomeModal = props => {

    const {
        actions: {
            hideAllModals
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                callbacks,
                onGoBack,
                reportedIncome
            }
        },
        modalHeaderProps,
        secondaryTopAnchors: [
            anchor_top_1
        ]
    } = props;

    const handleHideClick = () => {
        hideAllModals();
    };

    const handleLeftButtonClick = () => {
        onGoBack();
        handleHideClick();
    };

    const handleRightBtnClick = () => {
        callbacks.map(callback => {
            callback();
        });
        handleHideClick();
    };

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader
                    {...{
                        ...modalHeaderProps,
                        hideModal: hideAllModals
                    }}
                    closeAllModals
                    hideCloseIcon
                    hideAllModals={hideAllModals}
                />
            </div>
            <div className="gi-modal__body txt-left" id = 'expectedIncomeModal'>
                <FormattedMessage
                    id='modals.income_sources_notice'
                    tagName='p'
                    values={{ amount: currencyTools.getMoneyFormat(reportedIncome, true) }}
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    className='usa-button usa-button--outline gi-button gi-button__primary'
                    onClick={handleLeftButtonClick}
                    inputRef={boundAnchor(anchor_top_1)}
                >
                    <FormattedMessage id='button.go_back'/>
                </Button>
                <Button
                    className='usa-button gi-button gi-button__outline'
                    onClick={handleRightBtnClick}
                    inputRef={boundAnchor(anchor_1)}
                >
                    <FormattedMessage id='button.continue_without_changes'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default ExpectedIncomeModal;
